import { FC } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useTranslation } from '../i18n/useTranslation';

interface FatalErrorCardProps {
  message: string;
  onLogout: () => void;
}

const FatalErrorCard: FC<FatalErrorCardProps> = ({ message, onLogout }) => {
  const t = useTranslation();
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f8f8fa"
      p={3}
    >
      <Card
        sx={{
          maxWidth: 480,
          width: '100%',
          p: 5,
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: '12px',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1.5 }}>
          {t('errors.tryAgain')}
        </Typography>
        <Typography sx={{ color: 'text.secondary', mb: 3 }}>{message}</Typography>
        <Button variant="contained" onClick={onLogout} sx={{ textTransform: 'none' }}>
          {t('memberPending.logout')}
        </Button>
      </Card>
    </Box>
  );
};

export default FatalErrorCard;
